'use client';

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import { useState } from 'react';

import AllGameDaysModal from '@/modules/league/new-components/header/HeaderLeagueButtons/AllGameDaysModal';

interface HeaderLeagueButtonsClientProps {
  slug: string;
  sessionId: string;
  matchDateId: string;
  leagueId: string;
}

const HeaderLeagueButtons = ({
  slug,
  sessionId,
  matchDateId,
  leagueId,
}: HeaderLeagueButtonsClientProps) => {
  const [modalOpened, setModalOpened] = useState(false);

  const buttonClasses =
    '!md:text-sm rounded-md border border-gray-300 !bg-white !p-1 !text-xs font-semibold tracking-wider hover:!text-gray-900 shadow-xs';

  return (
    <>
      <div className='md:gap-3pt-11 mx-auto flex h-auto w-full max-w-screen-xl justify-between gap-0 p-3 lg:w-4/5'>
        <Button variant='link-gray' className={`${buttonClasses} !text-gray-700`}>
          <CustomLink
            href={`${process.env.NEXT_PUBLIC_PL_URL}/leagues/${slug}/session/${sessionId}?tab=standings`}
            className='p-1'
          >
            <FontAwesomeIcon icon={faArrowLeft} className='mr-2' />
            Back to league
          </CustomLink>
        </Button>
        <Button
          variant='link-gray'
          className={`${buttonClasses} p-1 !text-leagues-300`}
          onClick={() => {
            setModalOpened(true);
          }}
        >
          <div className='p-1'>All Game Days</div>
        </Button>
      </div>
      {modalOpened && (
        <AllGameDaysModal
          leagueId={leagueId}
          sessionId={sessionId}
          matchDateId={matchDateId}
          slug={slug}
          modalOpened={modalOpened}
          setIsModalOpen={setModalOpened}
        />
      )}
    </>
  );
};

export default HeaderLeagueButtons;
